import { useAuthStore } from '@/store/auth';
import { useLogout } from '@/api/queries/auth';
import { useMe } from '@/api/queries/user';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/routes/paths';

export function useAuth() {
  const hasToken = useAuthStore((s) => s.hasToken);
  const logoutMutation = useLogout();
  const logoutLocal = useAuthStore((s) => s.logout);
  const me = useMe({ enabled: hasToken });
  const navigate = useNavigate();

  return {
    hasToken,
    me: me.data ?? null,
    isLoading: me.isLoading,
    isError: me.isError,
    refetch: me.refetch,
    logout: async () => {
      await logoutMutation.mutateAsync();
      logoutLocal();
      navigate(paths.authLanding, { replace: true });
    },
  };
}
